/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each period's interest is added to the balance, so later periods earn interest on a larger and larger amount. Early on the effect is small, but because the growth compounds on itself the balance rises faster the longer the money is left invested, which is why time is the biggest factor in compound growth.`)
};

const es_cp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El interés de cada período se añade al saldo, de modo que los períodos posteriores ganan interés sobre cantidades cada vez mayores. Al principio el efecto es pequeño, pero debido a que el crecimiento se capitaliza a sí mismo el saldo sube más rápido cuanto más tiempo se deja el dinero invertido, por lo que el tiempo es el factor más importante en el crecimiento del interés compuesto.`)
};

const de_cp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zinsen jeder Periode werden dem Saldo hinzugefügt, sodass spätere Perioden Zinsen auf einen immer größeren Betrag erhalten. Zu Beginn ist der Effekt gering, aber da das Wachstum sich selbst verstärkt, steigt der Saldo umso schneller, je länger das Geld investiert bleibt — weshalb Zeit der größte Faktor beim Zinseszinswachstum ist.`)
};

const nl_cp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De rente van elke periode wordt bij het saldo opgeteld, dus latere perioden verdienen rente op steeds grotere bedragen. In het begin is het effect klein, maar omdat de groei op zichzelf samengesteld is, stijgt het saldo sneller naarmate het geld langer belegd blijft, dus tijd is de grootste factor in samengestelde groei.`)
};

const fr_cp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'intérêt de chaque période est ajouté au solde, de sorte que les périodes ultérieures gagnent des intérêts sur des montants de plus en plus grands. Au début, l'effet est petit, mais parce que la croissance se compose d'elle-même, le solde augmente plus rapidement plus l'argent est laissé investi longtemps, c'est pourquoi le temps est le plus grand facteur de croissance composée.`)
};

const it_cp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'interesse di ogni periodo viene aggiunto al saldo, quindi i periodi successivi guadagnano interessi su un importo sempre più grande. All'inizio l'effetto è piccolo, ma poiché la crescita si capitalizza su se stessa il saldo aumenta più velocemente quanto più a lungo il denaro è lasciato investito, motivo per cui il tempo è il fattore più importante nella crescita dell'interesse composto.`)
};

const pt_br2_cp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os juros de cada período são adicionados ao saldo, portanto os períodos posteriores geram juros sobre um valor cada vez maior. No início o efeito é pequeno, mas como o crescimento se capitaliza sobre si mesmo, o saldo cresce mais rápido quanto mais tempo o dinheiro fica investido, é por isso que o tempo é o maior fator do crescimento composto.`)
};

const pt_cp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O juro de cada período é adicionado ao saldo, de modo que os períodos posteriores ganham juro sobre uma quantidade cada vez maior. No início, o efeito é pequeno, mas como o crescimento se compõe a si mesmo, o saldo sobe mais depressa quanto mais tempo o dinheiro fica investido, razão pela qual o tempo é o fator mais importante no crescimento de juros compostos.`)
};

const ja_cp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各期間の利息は残高に加算されるため、後の期間はより大きな金額に対して利息を獲得します。最初は効果が小さいですが、成長がそれ自身に複利計算されるため、お金が投資されたままにされるほど残高がより速く上昇します。これは時間が複利成長の最大の要因である理由です。`)
};

const zh_cp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个周期的利息都会计入余额，因此后续周期会对越来越大的金额计息。初期这种效应较小，但由于增长会自我叠加，资金投资时间越长，余额增长速度就越快，这就是为什么时间是复利增长中最重要的因素。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_faq4_a", locale)
	if (locale === "en") return en_cp_faq4_a(inputs)
	if (locale === "es") return es_cp_faq4_a(inputs)
	if (locale === "de") return de_cp_faq4_a(inputs)
	if (locale === "nl") return nl_cp_faq4_a(inputs)
	if (locale === "fr") return fr_cp_faq4_a(inputs)
	if (locale === "it") return it_cp_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_cp_faq4_a(inputs)
	if (locale === "pt") return pt_cp_faq4_a(inputs)
	if (locale === "ja") return ja_cp_faq4_a(inputs)
	return zh_cp_faq4_a(inputs)
};